import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { InternalDerivedMetricReducerType } from 'redux/reducers/internal/DerivedMetrics'

export const selectInternalDerivedMetrics = createSelector(
  [
    (state: ApplicationState): InternalDerivedMetricReducerType =>
      state.InternalDerivedMetricStore
  ],
  (store) => ({
    ...store,
    metrics: Object.values(store.data).sort((a, b) =>
      a.name.localeCompare(b.name, 'sv')
    )
  })
)
